/* @flow */

import * as React from 'react';

import {formatTimestampForPinnedEntry} from 'nutshell-core/date-time/formatting';
import {SpacerGroup} from '../../../spacer/spacer-group';
import type {PinnedInfo} from './types';

import {
    TimelineHeaderActionText,
    TimelineHeaderTimestamp,
    type TimelineHeaderActionTextProps,
} from './';

import './timeline-header.css';

// TimelineHeaderProps
export type Props = {|
    ...TimelineHeaderActionTextProps,
    timestamp: number,
    isSmall?: boolean,
    pinnedInfo?: ?PinnedInfo,
|};

export function TimelineHeader(props: Props) {
    const {timestamp, isSmall, pinnedInfo, ...restProps} = props;

    return (
        <div styleName={isSmall ? 'header-container--small' : 'header-container'}>
            <SpacerGroup mb={isSmall ? 2 : 4}>
                <div className='flex'>
                    <TimelineHeaderTimestamp timestamp={timestamp} />
                    {pinnedInfo ? (
                        <div
                            styleName='pinned'
                            data-tip={
                                pinnedInfo.pinnedTime
                                    ? `Pinned ${formatTimestampForPinnedEntry(
                                          pinnedInfo.pinnedTime
                                      )}`
                                    : undefined
                            }
                        >
                            (Pinned by {pinnedInfo.pinnedByUser.name})
                        </div>
                    ) : (
                        undefined
                    )}
                </div>
            </SpacerGroup>
            <TimelineHeaderActionText {...restProps} />
        </div>
    );
}
